import React from 'react';

import DailyForm from './DailyForm';
import WeeklyForm from './WeeklyForm';
import HourlyForm from './HourlyForm';
import { DAILY, FREQUENCY_DEFAULT, WEEKLY } from './utils/constants';
import { FieldErrors, FieldValues, UseFormRegister } from 'react-hook-form';

interface Props {
  errors: FieldErrors<FieldValues>;
  register: UseFormRegister<FieldValues>;
  frequency: 'hourly' | 'daily' | 'weekly';
}

export default function FrequencyForm({ frequency, register, errors }: Props) {
  switch (frequency) {
    case FREQUENCY_DEFAULT:
      return <HourlyForm register={register} errors={errors} />;

    case DAILY:
      return <DailyForm register={register} errors={errors} />;

    case WEEKLY:
      return <WeeklyForm register={register} errors={errors} />;

    default:
      console.warn('Unknown frequency, returning empty string', frequency);
      return '';
  }
}
